import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/logo2.png';

const YEAR = new Date().getFullYear();

function Footer() {
  return (
    <>
      <footer id="contacto" className="relative bg-ink text-white">
        {/* Brand accent line */}
        <div className="h-[3px] w-full bg-gradient-to-r from-brand-400 via-brand-500 to-brand-300" />

        <div className="mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-20">
          <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
            {/* Brand */}
            <div className="lg:col-span-2">
              <img src={logo} alt="Fabrilum" className="h-10 w-auto" />
              <p className="mt-5 max-w-sm text-sm font-light leading-relaxed text-white/60">
                Fábrica argentina de artículos de iluminación. Más de 10 años
                diseñando y produciendo luminarias de calidad en Córdoba.
              </p>
              <a
                href="https://wa.me/+5493515395915?text=Quiero%20hacer%20un%20pedido"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-7 inline-flex items-center gap-2 rounded-full bg-brand-500 px-6 py-3 text-sm font-medium text-ink transition-colors hover:bg-brand-400"
              >
                Hacer un pedido
                <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
            </div>

            {/* Contact */}
            <div>
              <p className="text-xs font-medium uppercase tracking-wider2 text-brand-300">
                Contacto
              </p>
              <ul className="mt-5 space-y-3 text-sm font-light text-white/70">
                <li>
                  <a href="tel:+5493515395915" className="transition-colors hover:text-brand-300">
                    +54 9 351 539 5915
                  </a>
                </li>
                <li>
                  <a href="mailto:info@fabrilum.com.ar" className="transition-colors hover:text-brand-300">
                    info@fabrilum.com.ar
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.google.com/maps"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transition-colors hover:text-brand-300"
                  >
                    Pasaje Perú 4678, Los Boulevares,
                    <br />
                    Córdoba, Argentina
                  </a>
                </li>
              </ul>
            </div>

            {/* Navigation + social */}
            <div>
              <p className="text-xs font-medium uppercase tracking-wider2 text-brand-300">
                Navegación
              </p>
              <ul className="mt-5 space-y-3 text-sm font-light text-white/70">
                <li>
                  <Link to="/" className="transition-colors hover:text-brand-300">
                    Inicio
                  </Link>
                </li>
                <li>
                  <Link to="/productos" className="transition-colors hover:text-brand-300">
                    Productos
                  </Link>
                </li>
                <li>
                  <a href="/#nosotros" className="transition-colors hover:text-brand-300">
                    Nosotros
                  </a>
                </li>
              </ul>

              <a
                href="https://instagram.com/fabrilum?igshid=MzRlODBiNWFlZA=="
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="mt-6 inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors hover:border-brand-300 hover:text-brand-300"
              >
                <svg viewBox="0 0 30 30" fill="currentColor" className="h-5 w-5">
                  <circle cx="15" cy="15" r="4" />
                  <path d="M19.999,3h-10C6.14,3,3,6.141,3,10.001v10C3,23.86,6.141,27,10.001,27h10C23.86,27,27,23.859,27,19.999v-10C27,6.14,23.859,3,19.999,3z M15,21c-3.309,0-6-2.691-6-6s2.691-6,6-6s6,2.691,6,6S18.309,21,15,21z M22,9c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1s1,0.448,1,1C23,8.552,22.552,9,22,9z" />
                </svg>
              </a>
            </div>
          </div>

          <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-xs font-light text-white/40 md:flex-row">
            <p>© {YEAR} Fabrilum. Todos los derechos reservados.</p>
            <p>Hecho en Argentina 🇦🇷</p>
          </div>
        </div>
      </footer>

      {/* Floating WhatsApp button */}
      <a
        href="https://wa.me/+5493515395915?text=Quiero%20hacer%20un%20pedido"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Escribinos por WhatsApp"
        className="group fixed bottom-6 right-6 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-card transition-transform duration-300 hover:scale-110"
      >
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#25D366] opacity-30" />
        <svg viewBox="0 0 32 32" className="relative h-7 w-7 fill-white">
          <path d="M16.004 3.2c-7.07 0-12.8 5.73-12.8 12.8 0 2.26.6 4.46 1.73 6.4L3.2 28.8l6.57-1.72a12.74 12.74 0 0 0 6.23 1.6h.01c7.06 0 12.8-5.73 12.8-12.8 0-3.42-1.33-6.63-3.75-9.05a12.7 12.7 0 0 0-9.06-3.63zm0 23.3h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-4 1.05 1.07-3.9-.25-.4a10.55 10.55 0 0 1-1.62-5.64c0-5.86 4.77-10.63 10.63-10.63 2.84 0 5.5 1.11 7.51 3.12a10.56 10.56 0 0 1 3.11 7.52c0 5.86-4.77 10.62-10.63 10.62zm5.83-7.96c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.71.16-.21.32-.82 1.04-1 1.25-.18.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.9-1.78-2.22-.18-.32-.02-.49.14-.65.14-.14.32-.37.48-.55.16-.18.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.72-.98-2.35-.26-.62-.52-.54-.71-.55l-.61-.01c-.21 0-.55.08-.84.4-.29.32-1.1 1.08-1.1 2.63 0 1.55 1.13 3.05 1.29 3.26.16.21 2.23 3.4 5.4 4.77.75.32 1.34.52 1.8.66.76.24 1.44.21 1.99.13.61-.09 1.89-.77 2.16-1.52.27-.74.27-1.38.19-1.51-.08-.13-.29-.21-.61-.37z" />
        </svg>
      </a>
    </>
  );
}

export default Footer;
